import { render } from "./OpenPositions.vue?vue&type=template&id=c36b2fc8&scoped=true"
import script from "./OpenPositions.vue?vue&type=script&lang=js"
export * from "./OpenPositions.vue?vue&type=script&lang=js"

import "./OpenPositions.vue?vue&type=style&index=0&id=c36b2fc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36b2fc8"]])

export default __exports__